import parse from "html-react-parser";
import DOMPurify from "dompurify";

export const safeHtmlToReact = (html: string) => {
  // Add a DOMPurify hook to enforce rel="noopener noreferrer" on target="_blank" links
  DOMPurify.addHook("afterSanitizeAttributes", function (node) {
    if (node.tagName === "A" && node.getAttribute("target") === "_blank") {
      let rel = node.getAttribute("rel") || "";
      const relTokens = rel.split(/\s+/).filter(Boolean);
      if (!relTokens.includes("noopener")) relTokens.push("noopener");
      if (!relTokens.includes("noreferrer")) relTokens.push("noreferrer");
      node.setAttribute("rel", relTokens.join(" "));
    }
  });

  return parse(
    DOMPurify.sanitize(html, {
      ALLOWED_TAGS: [
        "a",
        "b",
        "strong",
        "i",
        "em",
        "u",
        "p",
        "br",
        "ul",
        "ol",
        "li",
        "span",
        "div",
        "code",
        "pre",
        "blockquote",
        "img",
      ],
      ALLOWED_ATTR: ["href", "title", "target", "rel", "src", "alt"],
      ALLOW_ARIA_ATTR: false,
      ALLOW_DATA_ATTR: false,
      RETURN_DOM: false,
    }),
  );
};
